// import "rsuite/dist/styles/rsuite-default.css";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setGroup, getGroupState } from "redux/slices/group-slice";
import { useEffect } from "react";
import { CURRENT_GROUP_ID, IDLE } from "utils/constants";
import {
  fetchAvailableGroups,
  getAvailableGroupsStatus,
  getAvailableGroupsData,
} from "redux/slices/available-groups-slice";
import { getRequest } from "utils/httpClient";
import * as storage from "utils/local-storage";

const InitializeGroupState = (path: string) => {
  const isSlugUrl = path.includes("/g/");
  const dispatch = useAppDispatch();
  const currentGroupState = useAppSelector(getGroupState);
  const availableGroupsStatus = useAppSelector(getAvailableGroupsStatus);
  const groups = useAppSelector(getAvailableGroupsData);

  useEffect(() => {
    if (availableGroupsStatus === IDLE) {
      dispatch(fetchAvailableGroups());
    }
  }, [availableGroupsStatus, dispatch]);

  // 1. Look for local storage group in available groups. If found, set as current group.
  // 2. If #1 not found, fetch group data for local storage group id. If found, set as current group,
  // otherwise just set current group as first available group (this might never happen?).
  useEffect(() => {
    if (currentGroupState.id !== "" || isSlugUrl) {
      return;
    }
    const localStorageGroupId = storage.local.getItem(CURRENT_GROUP_ID);

    const currentGroup = groups.find((availableGroup) => {
      return localStorageGroupId === availableGroup.id;
    });

    if (currentGroup && currentGroup.settings) {
      dispatch(setGroup(currentGroup));
    } else if (localStorageGroupId) {
      getRequest(`/v2/groups/group/${localStorageGroupId}`)
        .then((data) => {
          if (data) {
            dispatch(setGroup(data));
          } else {
            throw Error(`Group with id ${localStorageGroupId} not found`);
          }
        })
        .catch(() => {
          // TODO: Decide if we want to add toast package to use here
          // toast.error("Something went wrong");
          console.error("Something went wrong");
        });
    } else if (groups.length !== 0) {
      dispatch(setGroup(groups[0]));
    }
  }, [groups, currentGroupState.id, isSlugUrl, dispatch]);
};

export default InitializeGroupState;
